/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLanguageDetection = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9 2v2H4v5H2V2zM4 15H2v7h7v-2H4zm16 0h2v7h-7v-2h5zM15 4V2h7v7h-2V4zM7 9h5.946c-.142 1.337-.565 2.768-1.3 3.906C11.22 12.296 11 11.63 11 11H9c0 1.225.47 2.404 1.255 3.382-.433.299-.921.52-1.472.642l.434 1.952a6.168 6.168 0 0 0 2.544-1.224C12.919 16.525 14.374 17 16 17v-2c-1.1 0-2.069-.285-2.854-.74 1.105-1.573 1.656-3.536 1.809-5.26H17V7H7z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgLanguageDetection as LanguageDetection };
